(() => {
  const RUN_CLASS = "dtf-cards";

  const map = {
    "10 x 14": { code: "A6", dim: "10 × 14 cm", icon: "https://cdn.shopify.com/s/files/1/0995/8847/3157/files/format-printotex-01.svg?v=1765791300" },
    "14 x 21": { code: "A5", dim: "14 × 21 cm", icon: "https://cdn.shopify.com/s/files/1/0995/8847/3157/files/format-printotex-02.svg?v=1765791300" },
    "21 x 28": { code: "A4", dim: "21 × 28 cm", icon: "https://cdn.shopify.com/s/files/1/0995/8847/3157/files/format-printotex-03.svg?v=1765791300" },
    "28 x 42": { code: "A3", dim: "28 × 42 cm", icon: "https://cdn.shopify.com/s/files/1/0995/8847/3157/files/format-printotex-04.svg?v=1765791299" },
    "42 x 57": { code: "A2", dim: "42 × 57 cm", icon: "https://cdn.shopify.com/s/files/1/0995/8847/3157/files/format-printotex-05.svg?v=1765791300" },
    "100 x 57": { code: "1m", dim: "100 × 57 cm", icon: "https://cdn.shopify.com/s/files/1/0995/8847/3157/files/format-printotex-06.svg?v=1765791299" },
    "200 x 57": { code: "2m", dim: "200 × 57 cm", icon: "https://cdn.shopify.com/s/files/1/0995/8847/3157/files/format-printotex-07.svg?v=1765791300" },
  };

  const normalizeKey = (raw) =>
    (raw || "")
      .toLowerCase()
      .replace(/×/g, "x")
      .replace(/\s+/g, " ")
      .replace(/\s*cm/g, "")
      .trim();

  const findVariantFieldset = () => {
    // 1) Priorité: fieldset dans variant-picker (souvent le cas)
    const pickers = document.querySelectorAll("variant-picker");
    for (const vp of pickers) {
      const fs = vp.querySelector("fieldset");
      if (fs) return fs;
    }

    // 2) Fallback: premier fieldset dans la zone produit
    const candidates = document.querySelectorAll(".product-form__input fieldset, form[action*='/cart/add'] fieldset, main fieldset");
    for (const fs of candidates) {
      // On essaye de valider: contient des radios + labels swatch
      if (fs.querySelector("input[type='radio']") && fs.querySelector("label.label-swatch")) return fs;
    }

    return null;
  };

  const injectTitleOnce = (fieldset) => {
    if (!fieldset || fieldset.dataset.dtfTitleInjected === "1") return;

    // évite duplication si rerender
    if (fieldset.previousElementSibling && fieldset.previousElementSibling.classList?.contains("dtf-format-title")) {
      fieldset.dataset.dtfTitleInjected = "1";
      return;
    }

    const title = document.createElement("div");
    title.className = "dtf-format-title";
    title.innerHTML = `
      <span class="dtf-format-title__icon" aria-hidden="true">
        <svg viewBox="0 0 24 24">
          <path d="M6 2h9l3 3v17H6V2zm9 1.5V6h2.5L15 3.5z"
                fill="none" stroke="currentColor" stroke-width="1.8" />
        </svg>
      </span>
      <span class="dtf-format-title__text">Sélectionnez votre format d'impression</span>
    `;

    fieldset.insertAdjacentElement("beforebegin", title);
    fieldset.dataset.dtfTitleInjected = "1";
  };

  const transformLabels = () => {
    const labels = Array.from(document.querySelectorAll("variant-picker label.label-swatch, .product-form__input label.label-swatch"));

    labels.forEach((label) => {
      if (label.classList.contains("dtf-format-card")) return;

      const raw = (label.getAttribute("title") || label.textContent || "").trim();
      const key = normalizeKey(raw);

      const conf = map[key];
      if (!conf) return;

      const iconHtml =
        conf.icon && conf.icon.startsWith("http")
          ? `<span class="dtf-picto"><img src="${conf.icon}" alt="" loading="lazy"></span>`
          : "";

      label.classList.add("dtf-format-card");
      label.innerHTML = `
        ${iconHtml}
        <span class="dtf-code">${conf.code}</span>
        <span class="dtf-dim">${conf.dim}</span>
      `;
    });
  };

  const syncActive = () => {
    const allLabels = Array.from(document.querySelectorAll("variant-picker label.label-swatch.dtf-format-card, .product-form__input label.label-swatch.dtf-format-card"));
    allLabels.forEach((l) => l.classList.remove("dtf-active"));

    const checked = document.querySelector("variant-picker input[type='radio']:checked, .product-form__input input[type='radio']:checked");
    if (!checked) return;

    const label = checked.closest("fieldset, .product-form__input, variant-picker")?.querySelector(`label[for="${checked.id}"]`);
    if (label) label.classList.add("dtf-active");
  };

  const run = () => {
    if (!document.body.classList.contains(RUN_CLASS)) return;

    const fieldset = findVariantFieldset();
    injectTitleOnce(fieldset);

    transformLabels();
    syncActive();
  };

  // Run initial + reruns (thèmes qui hydratent tard)
  const boot = () => {
    run();
    setTimeout(run, 200);
    setTimeout(run, 800);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  // Sur changement de variant
  document.addEventListener("change", (e) => {
    if (!document.body.classList.contains(RUN_CLASS)) return;
    if (e.target && e.target.matches("input[type='radio']")) {
      syncActive();
    }
  });

  // Observe rerender Shopify
  const obs = new MutationObserver(() => run());
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();
